import Immutable from 'immutable';
import * as AssetBusinessType from 'ecosystem-marketplace-core/constants/groupTags/AssetBusinessType';
import * as AssetPageFeature from 'ecosystem-marketplace-core/constants/groupTags/AssetPageFeature';
import * as AssetPageType from 'ecosystem-marketplace-core/constants/groupTags/AssetPageType';
import supportedLanguages from 'ecosystem-marketplace-core/constants/groupTags/SupportedLanguages';
import * as Tier from 'ecosystem-marketplace-core/constants/groupTags/Tier';
import * as PlanType from 'ecosystem-marketplace-core/constants/pricings/PlanType';
/* @ts-expect-error module is untyped */

import { cleanObject } from 'ecosystem-marketplace-core/utils/formatters';
import * as ThemeQueryField from '../constants/ThemeQueryField';
import * as ThemeSort from '../constants/ThemeSort';
export const PRICE_RANGE_MIN = 'priceRangeMin';
export const PRICE_RANGE_MAX = 'priceRangeMax';
export const THEME_QUERY_FIELD_NAMES = Object.values(ThemeQueryField);
const MULTI_QUERY_FIELDS = [ThemeQueryField.OFFERING_IDS, ThemeQueryField.BUSINESS_TYPES, ThemeQueryField.PAGE_TYPES, ThemeQueryField.PAGE_FEATURES, ThemeQueryField.SORT_FIELDS, ThemeQueryField.LANGUAGES, ThemeQueryField.TAGS, ThemeQueryField.PROVIDERS, ThemeQueryField.TIERS];
const SINGLE_QUERY_FIELDS = [ThemeQueryField.SEARCH, ThemeQueryField.PLAN_TYPE, ThemeQueryField.MIN_OVERALL_RATING, ThemeQueryField.HAS_FREE_SUPPORT, ThemeQueryField.MIN_REVIEW_COUNT, ThemeQueryField.PORTAL_COMPATIBLE];
const VALID_QUERY_VALUES = {
  [ThemeQueryField.BUSINESS_TYPES]: Object.values(AssetBusinessType),
  [ThemeQueryField.PAGE_FEATURES]: Object.values(AssetPageFeature),
  [ThemeQueryField.PAGE_TYPES]: Object.values(AssetPageType),
  [ThemeQueryField.PLAN_TYPE]: [PlanType.FREE, PlanType.ONE_TIME],
  [ThemeQueryField.SORT_FIELDS]: Object.values(ThemeSort),
  [ThemeQueryField.LANGUAGES]: supportedLanguages,
  [ThemeQueryField.TIERS]: Object.values(Tier)
};

function hasValidityCheck(str) {
  return str in VALID_QUERY_VALUES;
}

export const THEME_QUERY_FILTER_ORDER = [ThemeQueryField.BUSINESS_TYPES, ThemeQueryField.PAGE_TYPES, ThemeQueryField.PAGE_FEATURES, ThemeQueryField.PLAN_TYPE, ThemeQueryField.PRICE_RANGE, ThemeQueryField.PORTAL_COMPATIBLE, ThemeQueryField.TIERS, ThemeQueryField.MIN_OVERALL_RATING, ThemeQueryField.HAS_FREE_SUPPORT, ThemeQueryField.PROVIDERS, ThemeQueryField.TAGS];
export const DEFAULT_THEME_QUERY_LIMIT = 24;
export const DEFAULT_THEME_SORT_VALUE = ThemeSort.INSTALL_COUNT_DESC;
const defaults = {
  [ThemeQueryField.SEARCH]: null,
  [ThemeQueryField.OFFERING_IDS]: Immutable.Set(),
  [ThemeQueryField.BUSINESS_TYPES]: Immutable.Set(),
  [ThemeQueryField.PAGE_TYPES]: Immutable.Set(),
  [ThemeQueryField.PAGE_FEATURES]: Immutable.Set(),
  [ThemeQueryField.PLAN_TYPE]: null,
  [ThemeQueryField.PRICE_RANGE]: null,
  [ThemeQueryField.PORTAL_COMPATIBLE]: null,
  [ThemeQueryField.TIERS]: Immutable.Set(),
  [ThemeQueryField.MIN_OVERALL_RATING]: null,
  [ThemeQueryField.HAS_FREE_SUPPORT]: null,
  [ThemeQueryField.SORT_FIELDS]: Immutable.Set(),
  [ThemeQueryField.LIMIT]: DEFAULT_THEME_QUERY_LIMIT,
  [ThemeQueryField.OFFSET]: 0,
  [ThemeQueryField.MIN_REVIEW_COUNT]: null,
  [ThemeQueryField.PROVIDERS]: Immutable.Set(),
  // TODO finalize
  [ThemeQueryField.LANGUAGES]: Immutable.Set(),
  [ThemeQueryField.TAGS]: Immutable.Set()
};

class ThemeQuery extends Immutable.Record(defaults) {
  constructor(json = {}) {
    const jsonCopy = Object.keys(json).reduce((final, queryField) => {
      let queryValue = json[queryField];

      if (typeof queryValue === 'function') {
        queryValue = queryValue();
      }

      if (MULTI_QUERY_FIELDS.includes(queryField)) {
        queryValue = Array.isArray(queryValue) ? queryValue : [queryValue];
      } else if (SINGLE_QUERY_FIELDS.includes(queryField)) {
        queryValue = Array.isArray(queryValue) ? queryValue[0] : queryValue;
      }

      switch (queryField) {
        case ThemeQueryField.OFFERING_IDS:
          {
            queryValue = queryValue.reduce((finalOfferingIds, offeringId) => {
              const parsedOfferingId = parseInt(offeringId, 10);
              return !isNaN(parsedOfferingId) ? [...finalOfferingIds, parsedOfferingId] : finalOfferingIds;
            }, []);
            break;
          }

        case ThemeQueryField.MIN_OVERALL_RATING:
          {
            const parsedQueryValue = parseInt(queryValue, 10);
            queryValue = !isNaN(parsedQueryValue) && parsedQueryValue > 0 && parsedQueryValue < 5 ? parsedQueryValue : null;
            break;
          }

        case ThemeQueryField.HAS_FREE_SUPPORT:
        case ThemeQueryField.PORTAL_COMPATIBLE:
          {
            queryValue = typeof queryValue === 'boolean' ? queryValue : queryValue === 'true' ? true : queryValue === 'false' ? false : null;
            break;
          }

        default:
          break;
      }

      if (hasValidityCheck(queryField)) {
        const validQueryValues = VALID_QUERY_VALUES[queryField];

        if (Array.isArray(queryValue)) {
          queryValue = queryValue.filter(value => validQueryValues.includes(value));
        } else if (!validQueryValues.includes(queryValue)) {
          queryValue = null;
        }
      }

      if (Array.isArray(queryValue)) {
        queryValue = queryValue.length ? Immutable.Set(queryValue) : null;
      }

      return Object.assign({}, final, {
        [queryField]: queryValue
      });
    }, {});
    super(cleanObject(jsonCopy));
  }

}

export default ThemeQuery;